import { render, staticRenderFns } from "./RepseRequests.vue?vue&type=template&id=252ffcdb"
import script from "./RepseRequests.vue?vue&type=script&lang=js"
export * from "./RepseRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports